import { CloseOutlined } from '@ant-design/icons';
import { Button, Flex, Typography } from 'antd';

export const Header = ({
  title,
  resetCurrentItem,
}: {
  title: string;
  resetCurrentItem: () => void;
}) => {
  return (
    <>
      <Flex justify="end">
        <Button icon={<CloseOutlined />} onClick={() => resetCurrentItem()} />
      </Flex>
      <Flex justify="center">
        <Typography.Title level={3}>{title}</Typography.Title>
      </Flex>
    </>
  );
};
